import React, { useEffect, useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  Input,
  ModalHeader,
} from "reactstrap"
import ProductView from "./ProductView"
import DeleteModel from "../../common/deleteModel/deleteModel"
import { dateFormat } from "pages/Common"
import toast from "react-hot-toast"
import BookingTable from "pages/Reports/Booking/BookingTable"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import jsPDF from "jspdf"
import { InvoiceHtml } from "pages/Reports/Booking/invoicePDF"
import { font } from "pages/Reports/Booking/font"
import { routes } from "routes/path"
import useApi from "common/ApiMiddlewere"
import InvoiceDetalis from "pages/Invoices/InvoiceDetalis"
import GetObjectsByValues from "_mock/Static_data"
import appConfig from "Api/app.config"
import CommonModel from "./CommonModel"
import TransactionModel from "./TransactionModel"
import CreditNoteModal from "./CreditNoteModal"
import { useSelector } from "react-redux"


function Booking() {
  document.title = `Bookings | ${localStorage.getItem("ShopName")}`
  const { deleteApi, getApi, postApi, putApi } = useApi()

  const navigate = useNavigate()
  const ref = useRef(null)
  let { pathname } = useLocation()

  // useStates
  const [tableData, setTableData] = useState([])
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [productViewId, setProductViewId] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [statusCancel, setStatusCancel] = useState(false)
  const [status, setStatus] = useState(0)
  const [TotalRecords, setTotalRecords] = useState(0.0)
  const [dateDisble, setdateDisble] = useState(false)
  const [date, setdate] = useState([new Date(), new Date()])
  const [BookingIdandStatusId, setBookingIdandStatusId] = useState({ bookingId: "", statusId: "", productId: "" })
  const [flag, setFlag] = useState('')
  const [CommonModelFlag, setCommonModelFlag] = useState(false)
  const [pageSize, setpageSize] = useState(20)
  const [displayStart, setDisplayStart] = useState(1)
  const [searchText, setSearchText] = useState("")
  const [transactionModelFlag, setTransactionModelFlag] = useState(false)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [billNo, setBillNo] = useState()
  const financeAmountShowHide = useSelector(state => state.ReduxData.finaceAmountShow);

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setpageSize(pageSize)
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
  }

  const statusValue = status => {
    if (status) {
      setStatus(parseInt(status))
    }
  }

  // handlers
  const toggle = () => {
    setModal(!modal)
  }
  // handlers
  const toggle1 = () => {
    setModal1(!modal1)
  }

  const bookingReportApi = () => {
    setIsLoading(true)
    postApi("Booking/booking-list", {
      fromDate: !dateDisble
        ? null
        : date[0]
          ? dateFormat(date[0], "yyyy-MM-dd")
          : new Date().toISOString().slice(0, 10),
      toDate: !dateDisble
        ? null
        : date[1]
          ? dateFormat(date[1], "yyyy-MM-dd")
          : new Date().toISOString().slice(0, 10),
      displayStart: displayStart,
      status: parseInt(status),
      pageSize: pageSize,
      searchText: searchText.trim(),
      OnApproved: false,
      sortColumn: "",
      sortOrder: "",
    }).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data.BookingList)
        setTotalRecords(data.TotalRecords)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  // booking list API useEffect
  useEffect(() => {
    setStatusCancel(false)
    if (date[1] != undefined) {
      bookingReportApi()
    }
  }, [
    modal,
    statusCancel,
    status,
    date,
    searchText,
    displayStart,
    dateDisble,
    pageSize,
  ])

  //  Delete Booking handler
  const handleDelete = bookingDeleteId => {
    setIsLoading(true)
    if (bookingDeleteId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this booking permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`booking/delete?id=${bookingDeleteId}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== bookingDeleteId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Booking deleted successfully", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Booking",
                  text: data,
                })
              }
              setIsLoading(false)
            }
          )
        } else {
          setIsLoading(false)
        }
      })
    }
  }

  const toggleCommon = () => {
    if (CommonModelFlag) {
      setStatusCancel(true)
    }
    else {
      setStatusCancel(false)
    }
    setCommonModelFlag(!CommonModelFlag)
  }

  // Booking table in change status handler
  const handleBookingStatus = (bookingId, statusId, row) => {
    if (statusId == 4) {
      toggleCommon()
      setFlag("cancel")
      setBookingIdandStatusId({ bookingId: bookingId, statusId: statusId })
    } else if (statusId == 2) {
      toggleCommon()
      setFlag("booking")
      setBookingIdandStatusId({ bookingId: bookingId, statusId: statusId })
    } else if (statusId == 3) {
      setFlag("booking")
      toggleCommon()
      setBookingIdandStatusId({ bookingId: bookingId, statusId: statusId })
    } else if (statusId == 5) {
      setFlag("cancelHold")
      toggleCommon()
      setBookingIdandStatusId({ bookingId: bookingId, statusId: statusId })
    }
    else {
      setIsLoading(true)
      if ((bookingId, statusId)) {
        DeleteModel.confirmDeleteInquiry({
          title: "Are you sure you want to change status?",
          text: "If you change the status of this item, the status of all the product inside it will be changed.",
          isMobile,
        }).then(response => {
          if (response == true) {
            const productId = ""
            putApi("Booking/change-Status", {
              bookingId: bookingId == "" ? 0 : bookingId,
              bookingItemId: productId == "" ? 0 : productId,
              BookingStatus: parseInt(statusId),
            }).then(({ data, status }) => {
              if (status === 200) {
                bookingReportApi()
                toast.success("Status change sucessfully", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                toast.error(data, {
                  style: {
                    fontSize: "15px",
                  },
                })
              }
              setIsLoading(false)
            })
          } else {
            setStatusCancel(true)
            setIsLoading(false)
          }
        })
      }
    }
    setIsLoading(false)
  }

  // settle transaction handler
  const handleSettleModel = (bookingId) => {
    toggleCommon()
    setFlag("settle")
    setBookingIdandStatusId({ bookingId: bookingId, statusId: 6 })
  }

  const toggleTransaction = () => {
    setTransactionModelFlag(!transactionModelFlag)
  }

  // view all transaction handler
  const handleTransaction = (bookingId, billNo) => {
    if (bookingId) {
      setBillNo(billNo)
      setBookingIdandStatusId({ ...BookingIdandStatusId, bookingId: bookingId })
      toggleTransaction()
    }
  }

  // Update  Booking handler
  const handleEditBooking = bookingEditId => {
    if (bookingEditId) {
      navigate(routes.updatebooking, {
        state: {
          bookingEditId: bookingEditId,
        },
      })
    }
  }

  // view button : Product View handler
  const handleProductView = bookingViewId => {
    if (bookingViewId) {
      setProductViewId(bookingViewId)
      toggle()
    }
  }

  // view booking
  const handleViewBooking = bookingId => {
    setBookingIdandStatusId({ ...BookingIdandStatusId, bookingId: bookingId })
    toggle1()
  }

  const getBase64FromUrl = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      throw new Error('Failed to fetch the image.');
    }
  };

  const handlePrintPDf = async id => {
    setIsLoading(true)
    const {
      data: { ProfilePic },
    } = await getApi(`User/user-details?id=-1`) // async function name() {

    const html = await InvoiceHtml(id, getApi)
    const doc = new jsPDF({
      format: "a5",
      unit: "px",
      filters: ["ASCIIHexEncode"],
      compress: true,
    })
    // var imgData = "data:image/jpeg;base64," + imagebase64
    doc.addFileToVFS("NotoSansGujarati-Regular.ttf", font)
    doc.addFont(
      "NotoSansGujarati-Regular.ttf",
      "NotoSansGujarati-Regular",
      "normal"
    )


    const parts = ProfilePic.split('/');
    const key = parts[parts.length - 1];

    // if (ProfilePic) {
    //   doc.addImage(await handleDownload(key), "PNG", 16, 19, 45, 35)
    // }
    doc.setFont("NotoSansGujarati-Regular") // set font
    doc.html(html, {
      async callback(doc) {
        setIsLoading(false)

        await doc.autoPrint

        window.open(doc.output("bloburl"), "_blank")
      },
      margin: [10, 10, 10, 10],
    })
  }

  const handleDownloadPdf = async (id, BillNo) => {
    setIsLoading(true)
    const {
      data: { ProfilePic },
    } = await getApi(`User/user-details?id=-1`)

    const html = await InvoiceHtml(id, getApi)


    const doc = new jsPDF({
      format: "a5",
      unit: "px",
      filters: ["ASCIIHexEncode"],
      compress: true,
    })
    // var imgData = "data:image/jpeg;base64," + imagebase64
    doc.addFileToVFS("NotoSansGujarati-Regular.ttf", font)
    doc.addFont(
      "NotoSansGujarati-Regular.ttf",
      "NotoSansGujarati-Regular",
      "normal"
    )
    // if (ProfilePic) {
    //   doc.addImage(
    //     await getBase64FromUrl(
    //       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJNsszLg4hq5LhCVG6cAYC9Lv5-BEDO13tdhO1V8g-yZt2RoDeXluUnLZpUIDaPf0ji28&usqp=CAU"
    //     ),
    //     "PNG",
    //     15,
    //     17,
    //     45,
    //     35,
    //     "MEDIUM"
    //   )
    // }
    doc.setFont("NotoSansGujarati-Regular") // set font
    doc.html(html, {
      async callback(doc) {
        await doc.save(`invoice_${BillNo}.pdf`)
      },
      margin: [10, 10, 10, 10],
    })
    setIsLoading(false)
  }
  // Booking table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Bill No.",
        accessor: "BillNo",
        width: "4%",
        Cell: ({ row }) => {
          return <>
            {row.original.TotalProduct == 0 ? (
              <div style={{ color: "#E94560" }} >{row.original.BillNo}</div>
            ) : (
              <div
                style={{ cursor: "pointer", color: "#556ee6" }}
                onClick={() => {
                  handleViewBooking(row.original.Id)
                }}
              >
                {row.original.BillNo}
              </div>
            )}
          </>
        },
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Customer No.",
        accessor: "ContactNo1",
        width: "6%",
      },
      {
        Header: () => (
          <div style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            textAlign: "end"
          }}
          >
            Rent
          </div>
        ),
        accessor: "NetAmount",
        width: "7%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}
            >
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(Math.round(row?.original?.NetAmount) || 0)}
            </div>
          )
        },
      },
      {
        Header: () => (
          <div style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            textAlign: "end"
          }}
          >
            Credit Note Amt.
          </div>
        ),
        accessor: "CreditNoteAmount",
        width: "7%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}
            >
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.CreditNoteAmount || 0)}
            </div>
          )
        },
      },
      {
        Header: () => (
          <div style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            textAlign: "end"
          }}
          >
            Advance
          </div>
        ),
        accessor: "Advance",
        width: "7%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}
            >
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.Advance || 0)}
            </div>
          )
        },
      },
      {
        Header: "Remarks",
        accessor: "Remarks",
        width: "7%",
        Cell: ({ row }) => (
          <p
            className="mb-0"
            data-toggle="tooltip"
            data-placement="bottom"
            title={`${row.original.Remarks == null ? '' : row.original.Remarks}`}
          >
            {row.original.Remarks.length > 15
              ? `${row.original.Remarks.substr(0, 15)}...`
              : row.original.Remarks == ""
                ? "N/A"
                : row.original.Remarks}
          </p>
        ),
      },
      {
        Header: "Total Product",
        accessor: "TotalProduct",
        width: "4%",
        Cell: ({ row }) => (
          <div
            className="text-primary , text-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleProductView(row.original.Id)
            }}
          >
            {row.original.TotalProduct}
          </div>
        ),
      },
      {
        Header: "Booking Date",
        accessor: "BookingDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.BookingDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(
                row.original.BookingDate.split("T")[0],
                "dd/MM/yyyy"
              )}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Status
          </div>
        ),
        width: "8%",
        // width: 100,
        accessor: "MinStatus",
        Cell: ({ row }) => {
          const { MinStatus } = row.original;
          let obj;

          if (MinStatus === 1) {
            obj = GetObjectsByValues(1, 2, 3, 4);
          } else if (MinStatus === 2) {
            obj = GetObjectsByValues(2, 3, 4);
          } else if (MinStatus === 3) {
            obj = GetObjectsByValues(3);
          } else if (MinStatus === 4) {
            obj = GetObjectsByValues(4);
          }
          return <>
            <div
              className="textWrap"
              style={{
                height: "8px",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <Input
                type="select"
                onChange={e =>
                  handleBookingStatus(
                    row.original.Id,
                    e.target.value,
                    row.original
                  )
                }
                disabled={row.original.MinStatus == 4 || row.original.MinStatus == 3}
                defaultValue={row.original.MinStatus}
                bsSize="sm"
                className={`${MinStatus == 1 ? "booking-status-booking" : MinStatus == 2 ? "deliverd-status-booking" : MinStatus == 3 ? "return-status-booking" : MinStatus == 4 ? "cancle-status-booking" : 'hold-status-booking'} form-control`}
              >
                {obj?.map((item, index) => {
                  return (
                    <option key={index} className="bg-light text-dark" value={item.Value}>
                      {item.DisplayName}
                    </option>
                  )
                })}
              </Input>
            </div>
          </>
        }
        ,
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "Action",
        disableFilters: true,
        Cell: ({ row }) => {
          const renderDisabledIcon = (iconClass, tooltipId, onClickHandler = null, disabled = true) => (
            <li className="mytooltip">
              <i
                className={`fs-6 fas ${iconClass}`}
                id={tooltipId}
                style={{ cursor: disabled ? "not-allowed" : "pointer", color: disabled ? "#808080b3" : "#000000" }}
                onClick={onClickHandler}
              ></i>
              <span className="mytext">{tooltipId}</span>
            </li>
          );

          const renderActionButton = (iconClass, onClickHandler, text) => (
            <li className="mytooltip">
              <i
                className={`fs-6 fas ${iconClass}`}
                style={{ color: iconClass === "fa-print" ? "#f39900" : "#90499c", cursor: "pointer" }}
                onClick={onClickHandler}
              ></i>
              <span className="mytext">{text}</span>
            </li>
          );

          const renderEditButton = (rowId, editHandler) => (
            <li className="mytooltip">
              <i
                className="fs-6 fas fa-edit btn-edit"
                id={`edittooltip${rowId}`}
                onClick={() => editHandler(rowId)}
              ></i>
              <span className="mytext">Edit</span>
            </li>
          );


          return (
            <>
              {
                (
                  <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                    {(row.original.MinStatus === 4) || row.original.TotalProduct === 0 ? (
                      <>
                        {renderDisabledIcon("fa-edit btn-edit", `Edit`)}
                        {renderDisabledIcon("fa-print btn-edit", `Print`)}

                        {renderDisabledIcon("fa-download", `Download`)}
                        {row?.original?.FeedbackRemarks == "" ?
                          <li className="mytooltip">
                            <i
                              className="mdi mdi-comment-account"
                              style={{ color: "#556ee6", cursor: "pointer", fontSize: "17px" }}
                              onClick={() => handleFeedback(row.original)}
                            ></i>
                            <span className="mytext">Feedback</span>
                          </li>
                          :
                          <li className="mytooltip">
                            <i
                              className="mdi mdi-comment-account"
                              style={{ color: "#808080b3", fontSize: "17px" }}
                            ></i>
                            <span className="mytext">{row.original.FeedbackRemarks}</span>
                          </li>
                        }
                        <li className="mytooltip">
                          <i
                            className="fab fa-whatsapp"
                            style={{ cursor: "not-allowed", color: "#808080b3", fontSize: "15px" }}
                          ></i>
                          <span className="mytext">WhatsApp</span>
                        </li>
                        {renderActionButton("fas fa-balance-scale", () => handleSettleModel(row.original.Id, row.original.BillNo), "Settelment")}
                        <li className="mytooltip">
                          <i
                            className="fas fa-handshake"
                            style={{ color: "#556ee6", cursor: "pointer" }}
                            onClick={() => handleTransaction(row.original.Id, row.original.BillNo)}
                          ></i>
                          <span className="mytext">Transaction</span>
                        </li>
                        <li className="mytooltip">
                          <i
                            className="fab fa-whatsapp"
                            style={{ color: "#f39900", cursor: "pointer", fontSize: "15px" }}
                            onClick={() => whatappMessage(row.original, row.original.ContactNo1, row.original.Id)}
                          ></i>
                          <span className="mytext">WhatsApp Message</span>
                        </li>
                        <li className="mytooltip">
                          <i
                            className="fs-6 fas fa-trash-alt btn-delete"
                            id={`deleteTooltip${row.original.Id}`}
                            onClick={() => handleDelete(row.original.Id)}
                          ></i>
                          <span className="mytext">Delete</span>
                        </li>
                      </>
                    ) : row.original.MinStatus != 1 ? (<>
                      <>
                        {financeAmountShowHide
                          ?
                          renderEditButton(row.original.Id, handleEditBooking)
                          :
                          renderDisabledIcon("fa-edit btn-edit", `Edit`)
                        }
                      </>
                      {renderActionButton("fa-print", () => handlePrint(row.original.Id), "Print")}
                      {renderActionButton("fa-download", () => handleDownload(row.original.Id, row.original.BillNo), "Download")}
                      {row.original.FeedbackRemarks == "" ?
                        <li className="mytooltip">
                          <i
                            className="mdi mdi-comment-account"
                            style={{ color: "#556ee6", cursor: "pointer", fontSize: "17px" }}
                            onClick={() => handleFeedback(row.original)}
                          ></i>
                          <span className="mytext">Feedback</span>
                        </li>
                        :
                        <li className="mytooltip">
                          <i
                            className="mdi mdi-comment-account"
                            style={{ color: "#808080b3", fontSize: "17px" }}
                          ></i>
                          <span className="mytext">{row.original.FeedbackRemarks}</span>
                        </li>
                      }
                      <li className="mytooltip">
                        <i
                          className="fab fa-whatsapp"
                          style={{ color: "green", cursor: "pointer", fontSize: "15px" }}
                          onClick={() => whatapp(row.original.ContactNo1, row.original.Id)}
                        ></i>
                        <span className="mytext">WhatsApp</span>
                      </li>
                      {renderActionButton("fas fa-balance-scale", () => handleSettleModel(row.original.Id, row.original.BillNo), "Settelment")}
                      <li className="mytooltip">
                        <i
                          className="fas fa-handshake"
                          style={{ color: "#556ee6", cursor: "pointer" }}
                          onClick={() => handleTransaction(row.original.Id, row.original.BillNo)}
                        ></i>
                        <span className="mytext">Transaction</span>
                      </li>
                      <li className="mytooltip">
                        <i
                          className="fab fa-whatsapp"
                          style={{ color: "#f39900", cursor: "pointer", fontSize: "15px" }}
                          onClick={() => whatappMessage(row.original, row.original.ContactNo1, row.original.Id)}
                        ></i>
                        <span className="mytext">WhatsApp Message</span>
                      </li>
                      {renderDisabledIcon("fa-trash-alt btn-delete", `Delete`)}

                    </>) : (
                      <>
                        {renderEditButton(row.original.Id, handleEditBooking)}
                        {renderActionButton("fa-print", () => handlePrint(row.original.Id), "Print")}
                        {renderActionButton("fa-download", () => handleDownload(row.original.Id, row.original.BillNo), "Download")}
                        {row.original.FeedbackRemarks == "" ?
                          <li className="mytooltip">
                            <i
                              className="mdi mdi-comment-account"
                              style={{ color: "#556ee6", cursor: "pointer", fontSize: "17px" }}
                              onClick={() => handleFeedback(row.original)}
                            ></i>
                            <span className="mytext">Feedback</span>
                          </li>
                          :
                          <li className="mytooltip">
                            <i
                              className="mdi mdi-comment-account"
                              style={{ color: "#808080b3", fontSize: "17px" }}
                            ></i>
                            <span className="mytext">{row.original.FeedbackRemarks}</span>
                          </li>
                        }
                        <li className="mytooltip">
                          <i
                            className="fab fa-whatsapp"
                            style={{ color: "green", cursor: "pointer", fontSize: "15px" }}
                            onClick={() => whatapp(row.original.ContactNo1, row.original.Id)}
                          ></i>
                          <span className="mytext">WhatsApp</span>
                        </li>
                        <li className="mytooltip">
                          <i
                            className="fas fa-balance-scale"
                            style={{ cursor: "pointer", color: "#90499c" }}
                            onClick={() => handleSettleModel(row.original.Id, row.original.BillNo)}
                          ></i>
                          <span className="mytext">Settelment</span>
                        </li>
                        <li className="mytooltip">
                          <i
                            className="fas fa-handshake"
                            style={{ color: "#556ee6", cursor: "pointer" }}
                            onClick={() => handleTransaction(row.original.Id, row.original.BillNo)}
                          ></i>
                          <span className="mytext">Transaction</span>
                        </li>
                        <li className="mytooltip">
                          <i
                            className="fab fa-whatsapp"
                            style={{ color: "#f39900", cursor: "pointer", fontSize: "15px" }}
                            onClick={() => whatappMessage(row.original, row.original.ContactNo1, row.original.Id)}
                          ></i>
                          <span className="mytext">WhatsApp Message</span>
                        </li>
                        <li className="mytooltip">
                          <i
                            className="fs-6 fas fa-trash-alt btn-delete"
                            id={`deleteTooltip${row.original.Id}`}
                            onClick={() => handleDelete(row.original.Id)}
                          ></i>
                          <span className="mytext">Delete</span>
                        </li>
                      </>
                    )}
                  </ul >
                )
              }
            </>
          )
        },
      },
    ],
    [tableData, status, financeAmountShowHide]
  )

  // Create Booking handler
  const handleBookingClicks = () => {
    navigate(routes.createbooking)
  }

  const handleDownload = async (id, Billno) => {
    setIsLoading(true)
    getApi(`Report/booking-invoice?bookingId=${id}`).then(({ data, status }) => {
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `invoice_${Billno}.pdf`;

      link.click();

      window.URL.revokeObjectURL(link.href);
      setIsLoading(false)

    })
  };

  const handlePrint = async (id) => {
    setIsLoading(true)
    getApi(`Report/booking-invoice?bookingId=${id}`).then(({ data, status }) => {
      const byteCharacters = atob(data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url);

      newWindow.addEventListener('load', () => {
        newWindow.print();
      });
      setIsLoading(false)
    })
  };

  const whatapp = async (num, id) => {
    setIsLoading(true)

    postApi("Setting/setting-by-keys", {
      Key: ["WHATSAPP_MASSAGE"],
      userId: JSON.parse(localStorage.getItem("authUser")).ParentUserId > 0 ? JSON.parse(localStorage.getItem("authUser")).ParentUserId : JSON.parse(localStorage.getItem("authUser")).Id,
    })
      .then(async ({ data, status }) => {
        if (status === 200) {
          if (data[0]?.IsActive == true) {
            let { data: { InvoiceDetail, ProductList } } = await getApi(`Booking/invoice-detail?id=${id}`)
            let {
              Advance,
              BillNo,
              BillNotes,
              Discount,
              CustomerName,
              TotalRent,
              CGSTAmount,
              SGSTAmount,
              IGSTAmount,
              ShopName,
              Deposit,
              ShopAddress,
              NetAmount,
            } = InvoiceDetail

            setIsLoading(false)
            var Massage = data[0].Value
              .replaceAll("{SHOP_NAME}", ShopName)
              .replaceAll("{BILL_NO}", BillNo)
              .replaceAll("{CUSTOMER_NAME}", CustomerName)
              .replaceAll("{TAXABLE_AMOUNT}", TotalRent.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{CGST_AMOUNT}", CGSTAmount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{SGST_AMOUNT}", SGSTAmount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{IGST_AMOUNT}", IGSTAmount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{NET_AMOUNT}", NetAmount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{DISCOUNT}", Discount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{ADVANCE}", Advance.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll(
                "{DUE_AMOUNT}",
                (parseInt(NetAmount) - parseInt(Advance) - parseInt(Discount)).toLocaleString('en-IN', { style: 'currency', currency: 'INR' })
              )
              .replaceAll("{DEPOSIT}", Deposit.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
              .replaceAll("{BILL_NOTES}", BillNotes)
              .replaceAll("{ADDRESS}", ShopAddress)
              .replaceAll("<br>", '\n')

            var products = ''
            for (let i = 0; i < ProductList.length; i++) {
              var product = `{INDEX}. Product: {PRODUCT_CODE}, {PRODUCT_NAME}
      Delivery Date: {DELIVERY_DATE}
      Return Date: {RETURN_DATE}
      Rent: {RENT}\n\n`
              products += product
                .replaceAll("{INDEX}", (i + 1))
                .replaceAll("{PRODUCT_CODE}", ProductList[i].ProductCode)
                .replaceAll("{PRODUCT_NAME}", `(${ProductList[i].ProductTitle})`)
                .replaceAll(
                  "{DELIVERY_DATE}",
                  dateFormat(ProductList[i].DeliveryDate.split("T")[0], "dd/MM/yyyy")
                )
                .replaceAll(
                  "{RETURN_DATE}",
                  dateFormat(ProductList[i].ReturnDate.split("T")[0], "dd/MM/yyyy")
                )
                .replaceAll("{RENT}", ProductList[i].NetRent.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }))
            }
            Massage = Massage.replaceAll("{ITEMS}", products)
            // window.open(
            //   // `https://wa.me/+91${num}?text=${encodeURIComponent(`${message}`)}`,
            //   `https://wa.me/+91${num}?text=${encodeURIComponent(Massage)}`,
            //   "_blank",
            //   "width=1000,height=600,menubar=no,toolbar=no"
            // );
            window.open(
              `https://api.whatsapp.com/send?phone=91${num}&text=${encodeURIComponent(Massage)}`,
              "_blank",
              "width=1000,height=600,menubar=no,toolbar=no"
            );
          } else {
            setIsLoading(false)
            toast("Setting is not active", {
              icon: "⚠️",
              style: {
                fontSize: "15px",
              },
            })
          }

        } else {
          setIsLoading(false)
        }
      })
  }

  const whatappMessage = async (rowData, num, id) => {
    setIsLoading(true)
    postApi("Setting/setting-by-keys", {
      Key: ["BOOKING_WHATSAPP_MASSAGE"],
      userId: JSON.parse(localStorage.getItem("authUser")).ParentUserId > 0 ? JSON.parse(localStorage.getItem("authUser")).ParentUserId : JSON.parse(localStorage.getItem("authUser")).Id,
    })
      .then(async ({ data, status }) => {
        if (status === 200) {
          setIsLoading(false)
          var Massage = data[0].Value
            .replaceAll("{BILL_NO}", rowData?.BillNo)
            .replaceAll("{CUSTOMER_NAME}", rowData?.Name)
          window.open(
            `https://api.whatsapp.com/send?phone=91${num}&text=${encodeURIComponent(Massage)}`,
            "_blank",
            "width=1000,height=600,menubar=no,toolbar=no"
          );
        } else {
          setIsLoading(false)
        }
      })
  }

  const handleFeedback = (data) => {
    navigate(routes.feedback, {
      state: {
        data,
        GroupType: 1
      },
    })
  }

  return (
    <div className="page-content background">
      <div className="container-fluid">
        {isLoading && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <BookingTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              customPageSize={20}
              isLoading={isLoading}
              pagePerSize={pagePerSize}
              statusValue={statusValue}
              TotalRecords={TotalRecords}
              className="custom-header-css"
              dateDisble={dateDisble}
              setdateDisble={setdateDisble}
              date={date}
              setdate={setdate}
            />

            <Modal isOpen={modal} toggle={toggle} centered={true} size="lg" >
              <div className="modal-content" style={{ width: "1000px !important" }}>
                <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                  Products
                </ModalHeader>
                <ModalBody>
                  <ProductView
                    productViewId={productViewId}
                    modal={modal}
                    setModal={setModal}
                  />
                </ModalBody>
              </div>
            </Modal>


            <InvoiceDetalis
              toggle={toggle1}
              modal={modal1}
              bookingId={BookingIdandStatusId.bookingId}
            />

            <CommonModel
              modal={CommonModelFlag}
              toggle={toggleCommon}
              BookingandStatus={BookingIdandStatusId}
              flag={flag}
            />
            <TransactionModel
              modal={transactionModelFlag}
              toggle={toggleTransaction}
              BookingandStatus={BookingIdandStatusId}
              billNo={billNo}
            />

          </CardBody>
        </Card>
      </div>
    </div>
  )
}
Booking.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Booking